var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC2MdBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 184.895,
    height: 54.69,
    viewBox: "0 0 184.895 54.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31907",
    "data-name": "Path 31907",
    d: "M60.73,100.77l14.75,12.819V100.77Z",
    transform: "translate(-60.73 -100.77)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13457",
    "data-name": "Rectangle 13457",
    width: 14.75,
    height: 12.819,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31908",
    "data-name": "Path 31908",
    d: "M149.773,71.078,149.69,83.9l15.392-.152h13.547v-15L164.52,56.41V71.236l-14.747-.159Z",
    transform: "translate(-149.69 -56.41)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13459",
    "data-name": "Rectangle 13459",
    width: 28.935,
    height: 27.487,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google_Play_Store_badge_EN-01",
    transform: "translate(-18.05 -15.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31886",
    "data-name": "Path 31886",
    d: "M562.309,23.8a2.956,2.956,0,1,0,2.953,2.956A2.956,2.956,0,0,0,562.309,23.8Zm0,5.34a.989.989,0,1,1,0,.017Z",
    transform: "translate(-362.317 -5.616)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31887",
    "data-name": "Path 31887",
    d: "M566.9,28.975a.936.936,0,0,0-.331-.767,1.323,1.323,0,0,0-.866-.271H564.38v3.178h.661V30.09h.536l.625,1.025h.76l-.7-1.151A1.068,1.068,0,0,0,566.9,28.975Zm-1.323.5h-.529v-.919h.529c.453,0,.661.145.661.456S566.01,29.475,565.577,29.475Z",
    transform: "translate(-365.684 -8.384)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31888",
    "data-name": "Path 31888",
    d: "M258.526,47.991a3.307,3.307,0,0,1-1.058,1.868,2.976,2.976,0,0,1-1.918.645,3.035,3.035,0,0,1-2.645-1.571c-.063-.129-.119-.258-.172-.38a2.842,2.842,0,0,1-.112-.466,15.339,15.339,0,0,1-.089-2.027,15.176,15.176,0,0,1,.089-2.034,2.5,2.5,0,0,1,.284-.833,2.909,2.909,0,0,1,.992-1.078,3.049,3.049,0,0,1,3.667.251,3.356,3.356,0,0,1,.969,1.838h-1.362a1.9,1.9,0,0,0-.559-.9,1.653,1.653,0,0,0-1.055-.367,1.716,1.716,0,0,0-.777.185,1.617,1.617,0,0,0-.539.453,1.58,1.58,0,0,0-.331.727,11.305,11.305,0,0,0-.086,1.756,11.173,11.173,0,0,0,.086,1.752,1.617,1.617,0,0,0,.331.737,1.547,1.547,0,0,0,.539.44,1.468,1.468,0,0,0,.777.2,1.735,1.735,0,0,0,1.62-1.2Z",
    transform: "translate(-156.947 -17.543)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31889",
    "data-name": "Path 31889",
    d: "M299.7,46.059a10.792,10.792,0,0,0,.1,1.752,1.435,1.435,0,0,0,.331.737,1.71,1.71,0,0,0,1.323.638,1.541,1.541,0,0,0,.8-.2,1.438,1.438,0,0,0,.509-.44,1.653,1.653,0,0,0,.331-.737,10.637,10.637,0,0,0,.089-1.752,10.765,10.765,0,0,0-.089-1.756,1.623,1.623,0,0,0-.331-.727,1.508,1.508,0,0,0-.513-.453,1.805,1.805,0,0,0-.8-.185,1.709,1.709,0,0,0-.78.185,1.527,1.527,0,0,0-.532.453,1.4,1.4,0,0,0-.331.727,10.927,10.927,0,0,0-.1,1.756Zm-1.283,0a14.735,14.735,0,0,1,.089-2.04,2.612,2.612,0,0,1,.278-.833,3.049,3.049,0,0,1,.992-1.078,2.87,2.87,0,0,1,1.653-.489,2.9,2.9,0,0,1,1.683.5,2.811,2.811,0,0,1,.962,1.078,2.07,2.07,0,0,1,.3.833,18.469,18.469,0,0,1,.073,2.034,18.677,18.677,0,0,1-.073,2.027,2.119,2.119,0,0,1-.3.846,2.811,2.811,0,0,1-.949,1.078,2.956,2.956,0,0,1-1.683.5,2.877,2.877,0,0,1-1.653-.5,2.976,2.976,0,0,1-.992-1.068c-.056-.129-.109-.258-.165-.38a2.845,2.845,0,0,1-.112-.466,14.754,14.754,0,0,1-.089-2.027Z",
    transform: "translate(-187.662 -17.542)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31890",
    "data-name": "Path 31890",
    d: "M448.48,41.85h5.406v1.243H449.76v2.5h3.525v1.174H449.76v2.576h4.127v1.247H448.48V41.85Z",
    transform: "translate(-288.107 -17.698)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31891",
    "data-name": "Path 31891",
    d: "M499.492,47.991a3.263,3.263,0,0,1-1.061,1.868,2.953,2.953,0,0,1-1.908.645,2.913,2.913,0,0,1-1.653-.5,2.843,2.843,0,0,1-.992-1.068,3.793,3.793,0,0,1-.172-.38,2.073,2.073,0,0,1-.116-.466,14.764,14.764,0,0,1-.089-2.027,14.611,14.611,0,0,1,.089-2.034,2.362,2.362,0,0,1,.288-.833,3.032,3.032,0,0,1,4.652-.827A3.376,3.376,0,0,1,499.5,44.2h-1.356a2,2,0,0,0-.572-.9,1.653,1.653,0,0,0-1.051-.367,1.693,1.693,0,0,0-.774.185,1.541,1.541,0,0,0-.536.453,1.4,1.4,0,0,0-.331.727,11.185,11.185,0,0,0-.089,1.756,11.048,11.048,0,0,0,.089,1.752,1.435,1.435,0,0,0,.331.737,1.478,1.478,0,0,0,.536.44,1.455,1.455,0,0,0,.774.2,1.735,1.735,0,0,0,1.623-1.2Z",
    transform: "translate(-318.238 -17.543)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31892",
    "data-name": "Path 31892",
    d: "M539.918,43.024H537.6V41.85h5.922v1.174H541.2v7.565h-1.283V43.024Z",
    transform: "translate(-347.759 -17.698)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31893",
    "data-name": "Path 31893",
    d: "M252.37,87.964l4.831-6.23a2.446,2.446,0,0,0,.384-.7,2.8,2.8,0,0,0,.066-.582,1.921,1.921,0,0,0-.45-1.247,1.594,1.594,0,0,0-1.27-.546,1.653,1.653,0,0,0-1.217.479,2.136,2.136,0,0,0-.6,1.356H252.36a3.968,3.968,0,0,1,1.032-2.625,3.283,3.283,0,0,1,2.394-1.032,3.531,3.531,0,0,1,2.6,1.045,3.789,3.789,0,0,1,.281,4.831L254.7,87.862h4.715v1.812H252.37V87.961Z",
    transform: "translate(-156.835 -41.116)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31894",
    "data-name": "Path 31894",
    d: "M333.617,84.653,329.9,77.16h1.981l2.619,5.651,2.612-5.651h1.981l-3.717,7.489v5.244h-1.759V84.653Z",
    transform: "translate(-208.736 -41.332)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31895",
    "data-name": "Path 31895",
    d: "M376.552,88.081h2.242a2.523,2.523,0,0,0,2.288-1.111,2.193,2.193,0,0,0,.4-1.048,22.319,22.319,0,0,0,.076-2.315c0-1.108-.023-1.9-.076-2.381A2.209,2.209,0,0,0,381,80.063a2.457,2.457,0,0,0-2.2-1.078h-2.242v9.11ZM374.69,77.17h4.315a4.126,4.126,0,0,1,3.763,2.146,3.915,3.915,0,0,1,.559,1.5,24.237,24.237,0,0,1,.1,2.718,18.5,18.5,0,0,1-.149,2.867,3.35,3.35,0,0,1-.2.731,5.045,5.045,0,0,1-.331.661,4.431,4.431,0,0,1-1.511,1.488,4.179,4.179,0,0,1-2.344.625h-4.2V77.16Z",
    transform: "translate(-238.716 -41.332)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31896",
    "data-name": "Path 31896",
    d: "M409.353,83.3a15.408,15.408,0,0,0,.139,2.546,2.229,2.229,0,0,0,.486,1.078,2.188,2.188,0,0,0,.78.638,2.126,2.126,0,0,0,1.131.294,2.232,2.232,0,0,0,1.167-.294,2.073,2.073,0,0,0,.747-.638,2.269,2.269,0,0,0,.5-1.078,17.363,17.363,0,0,0,.122-2.546,17.7,17.7,0,0,0-.122-2.563,2.3,2.3,0,0,0-.5-1.065,2.252,2.252,0,0,0-.747-.661,2.688,2.688,0,0,0-1.167-.271,2.559,2.559,0,0,0-1.131.271,2.377,2.377,0,0,0-.78.661,2.252,2.252,0,0,0-.486,1.065,15.71,15.71,0,0,0-.139,2.563Zm-1.865,0a23.152,23.152,0,0,1,.126-2.976,3.515,3.515,0,0,1,.42-1.213,4.332,4.332,0,0,1,1.432-1.567,4.179,4.179,0,0,1,2.43-.721,4.269,4.269,0,0,1,2.457.721,4.226,4.226,0,0,1,1.409,1.574,3.149,3.149,0,0,1,.43,1.214A24.8,24.8,0,0,1,416.3,83.3a24.813,24.813,0,0,1-.109,2.953,3.227,3.227,0,0,1-.43,1.237,4.126,4.126,0,0,1-1.409,1.554,4.451,4.451,0,0,1-4.887,0,4.229,4.229,0,0,1-1.432-1.554l-.251-.552a4.3,4.3,0,0,1-.169-.684,23.036,23.036,0,0,1-.126-2.953Z",
    transform: "translate(-260.665 -41.103)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31897",
    "data-name": "Path 31897",
    d: "M449.282,86.108a4.834,4.834,0,0,1-1.547,2.721,4.338,4.338,0,0,1-2.794.942,4.259,4.259,0,0,1-2.424-.731,4.182,4.182,0,0,1-1.435-1.554c-.093-.2-.172-.377-.251-.552a3.976,3.976,0,0,1-.169-.684,22.426,22.426,0,0,1-.126-2.953,22.4,22.4,0,0,1,.126-2.976,3.586,3.586,0,0,1,.42-1.214,4.3,4.3,0,0,1,1.428-1.567,4.434,4.434,0,0,1,5.34.374,4.831,4.831,0,0,1,1.422,2.682h-1.984a2.777,2.777,0,0,0-.833-1.323,2.407,2.407,0,0,0-1.524-.536,2.516,2.516,0,0,0-1.134.271,2.359,2.359,0,0,0-.784.661,2.212,2.212,0,0,0-.479,1.065,14.965,14.965,0,0,0-.139,2.563,14.687,14.687,0,0,0,.139,2.546A2.358,2.358,0,0,0,443.8,87.56a2.13,2.13,0,0,0,1.134.294,2.526,2.526,0,0,0,2.361-1.746Z",
    transform: "translate(-282.786 -41.105)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31898",
    "data-name": "Path 31898",
    d: "M471.4,78.869H468.02V77.16h8.633v1.709h-3.393V89.893H471.4V78.869Z",
    transform: "translate(-301.186 -41.332)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31899",
    "data-name": "Path 31899",
    d: "M498.551,83.3a15.646,15.646,0,0,0,.132,2.546,2.226,2.226,0,0,0,.483,1.078,2.159,2.159,0,0,0,.78.638,2.136,2.136,0,0,0,1.141.294,2.242,2.242,0,0,0,1.161-.294,2.11,2.11,0,0,0,.741-.638,2.238,2.238,0,0,0,.5-1.078,15.382,15.382,0,0,0,.129-2.546,15.676,15.676,0,0,0-.129-2.563,2.265,2.265,0,0,0-.5-1.065,2.3,2.3,0,0,0-.741-.661,2.7,2.7,0,0,0-1.161-.271,2.569,2.569,0,0,0-1.141.271,2.345,2.345,0,0,0-.78.661,2.249,2.249,0,0,0-.483,1.065A15.954,15.954,0,0,0,498.551,83.3Zm-1.875,0a21.763,21.763,0,0,1,.129-2.976,3.662,3.662,0,0,1,.417-1.214,4.266,4.266,0,0,1,1.438-1.567,4.14,4.14,0,0,1,2.427-.721,4.3,4.3,0,0,1,2.46.721,4.222,4.222,0,0,1,1.4,1.574,2.993,2.993,0,0,1,.423,1.213,26.338,26.338,0,0,1,.109,2.976,26.367,26.367,0,0,1-.109,2.953,3.072,3.072,0,0,1-.433,1.237,4.122,4.122,0,0,1-1.4,1.554,4.365,4.365,0,0,1-2.46.731,4.441,4.441,0,0,1-3.869-2.285c-.089-.2-.169-.377-.241-.552a3.427,3.427,0,0,1-.172-.684,21.655,21.655,0,0,1-.129-2.953Z",
    transform: "translate(-320.356 -41.103)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31900",
    "data-name": "Path 31900",
    d: "M532.865,82.721H535.7a1.984,1.984,0,0,0,2.1-2.03,1.746,1.746,0,0,0-.622-1.445,2.113,2.113,0,0,0-1.376-.393h-2.94ZM531,77.153h4.828a3.733,3.733,0,0,1,2.513.83,3.442,3.442,0,0,1,1.22,2.721,3.543,3.543,0,0,1-2.381,3.531l2.86,5.651h-2.225l-2.553-5.446h-2.4v5.446H531Z",
    transform: "translate(-343.341 -41.325)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31901",
    "data-name": "Path 31901",
    d: "M293.72,77.73l5.254,7.569,5.195-7.569V90.358h-1.855V83.791h-.043l-3.31,4.755L295.6,83.791l-.026-.046,0,6.613H293.72V77.73Z",
    transform: "translate(-184.519 -41.714)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31902",
    "data-name": "Path 31902",
    d: "M347.29,41.437l5.2,5.271.02-5.648h1.316v9L348.642,44.8l-.03,5.264H347.29V41.437Z",
    transform: "translate(-220.376 -17.169)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31903",
    "data-name": "Path 31903",
    d: "M397.68,41.554l5.188,5.267.026-5.641h1.319v9l-5.185-5.271L399,50.177H397.68V41.554Z",
    transform: "translate(-254.104 -17.249)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40871",
    "data-name": "Group 40871"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31904",
    "data-name": "Path 31904",
    d: "M46.906,15.41H18.05V56.447H46.906V43.621H32.159V28.874H46.906V15.41Z",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31905",
    "data-name": "Path 31905",
    d: "M149.91,15.41h28.866V56.447H149.91V43.621h14.75V28.874H149.91V15.41Z",
    transform: "translate(-88.26)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31906",
    "data-name": "Path 31906",
    d: "M71.106,130.886,54.19,144.565l3.66-13.679,4.441-4.226,7.843,1.128.969,3.131",
    transform: "translate(-24.19 -74.465)",
    fill: "#208ce1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27432",
    "data-name": "Group 27432",
    transform: "translate(32.162 43.635)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27431",
    "data-name": "Group 27431",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13456",
    "data-name": "Rectangle 13456",
    width: 14.998,
    height: 13.034,
    transform: "translate(-0.169 -0.06)",
    fill: "#1679c8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27434",
    "data-name": "Group 27434",
    transform: "translate(61.577 28.967)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27433",
    "data-name": "Group 27433",
    transform: "translate(0)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31992",
    "data-name": "Path 31992",
    d: "M0,0H29.283V27.616H0Z",
    transform: "translate(-0.142 0.036)",
    fill: "#1679c8"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2MdBlue);
export default __webpack_public_path__ + "static/media/c2mdBlue.3167d7e34f67ab340bf84053943c6812.svg";
export { ForwardRef as ReactComponent };